export const performanceAppraisalData = [
  {
    Image: "user-32.jpg",
    Name: "Anthony Lewis",
    Designation: "Web Designer",
    Department: "Designing",
    AppraisalDate: "14 Jan 2024",
    Status: "Active",
    key: "1",
  },
  {
    Image: "user-09.jpg",
    Name: "Brian Villalobos",
    Designation: "Web Developer",
    Department: "Developer",
    AppraisalDate: "21 Jan 2024",
    Status: "Active",
    key: "2",
  },
  {
    Image: "user-01.jpg",
    Name: "Harvey Smith",
    Designation: "IOS Developer",
    Department: "Developer",
    AppraisalDate: "18 Feb 2024",
    Status: "Active",
    key: "3",
  },
  {
    Image: "user-33.jpg",
    Name: "Stephan Peralt",
    Designation: "Android Developer",
    Department: "Developer",
    AppraisalDate: "24 Feb 2024",
    Status: "Active",
    key: "4",
  },
  {
    Image: "user-34.jpg",
    Name: "Doglas Martini",
    Designation: "DevOps Engineer",
    Department: "DevOps",
    AppraisalDate: "11 Mar 2024",
    Status: "Active",
    key: "5",
  },
];
